<template>
  <div>
    <div class="p-d-flex p-flex-column">
      <div class="p-d-flex p-ai-center">
        <span>{{ __("Price per kWh") }}:</span>
        <p-vue-input-number
          v-model="localKWhPrice"
          mode="currency"
          currency="ILS"
          class="p-mx-2"
        />
      </div>
      <small class="p-mt-2"><strong>{{ __("The price includes VAT") }}</strong></small>
      <i-form-error :data="errors.kWhPrice" />
    </div>

    <i-form-error
      class="p-mt-2"
      :data="
        '* ' +
          __(
            'Note that the price will apply to new measurements that are registered only'
          )
      "
    />

    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
        @click="close"
        icon
        :label="__('Cancel')"
      >
      </p-vue-button>
      <p-vue-button
        :class="{
          submit: true,
          'p-button': true,
          'p-button-lg': true,
          'p-button-success': true,
          'p-button-rounded': true,
        }"
        @click="submit"
        :loading="btnLoading"
        icon
        :label="__('Save')"
      >
      </p-vue-button>
    </div>
  </div>
</template>

<script>
// import { dateFormat } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import { ValidationError } from "vue3-form-validation";
export default {
  plugins: { __ },
  props: {
    BID: Number,
    close: Function,
    kWhPrice: Number,
  },
  emits: ["refreshAllMeters"],
  data() {
    return {
      errors: {},
      btnLoading: false,
      localKWhPrice: 0,
    };
  },
  mounted() {
    this.localKWhPrice = this.kWhPrice;
  },
  methods: {
    validateFields() {
      this.valid = true;

      if (!this.localKWhPrice) {
        this.valid = false;
        this.errors.kWhPrice = __("Required field");
      }
    },

    submit() {
      try {
        this.validateFields();
        if (this.valid) {
          this.btnLoading = true;
          let procParams = [
            apiParam("BID", this.BID, apiPType.Int),
            apiParam("kWhPrice", this.localKWhPrice, apiPType.Float),
          ];
          callProc("WorkerApp_UpdatekWhPriceToBuilding", procParams)
            .then(() => {
              // result = JSON.parse(result);
              // console.log(result);
              showSuccessOrFailedModal(__("Data saved successfully!"));
              this.btnLoading = false;
              this.$emit("refreshAllMeters");
              this.close();
            })
            .catch(() => {
              errorReceived("WorkerApp_UpdatekWhPriceToBuilding");
            });
        }
      } catch (err) {
        if (!(err instanceof ValidationError)) console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.p-dropdown {
  width: 100%;
}

:deep(.svg) {
  color: var(--color-success);
  width: 18px;
  height: 18px;
}

.sms-to {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
}

.sms-to-checkbox {
  display: flex;
  align-items: center;
  gap: 7px;
}

.p-inputtextarea {
  width: 100%;
}
</style>
